import React from 'react';

const AboutUs = () => (
    <div style={{ padding: '2rem', maxWidth: '900px', margin: '0 auto', lineHeight: '1.6', background: "#fff" }}>
        <h1>About Us</h1>

        <p>
            <strong>RIYMS Microfinance</strong> is a financial services company registered under the
            <strong> Ministry of Corporate Affairs (MCA)</strong>, dedicated to providing accessible and inclusive
            credit solutions across India.
        </p>

        <h2>Our Mission</h2>
        <p>To empower individuals and small businesses by offering quick, reliable, and responsible financial services.</p>

        <h2>What We Offer</h2>
        <ul>
            <li>Micro loans for personal and business use</li>
            <li>Digital loan application and tracking platform</li>
            <li>Financial literacy and support</li>
        </ul>

        <h2>Why Choose Us?</h2>
        <ul>
            <li>Registered and regulated by MCA</li>
            <li>Transparent and ethical loan processing</li>
            <li>Technology-driven platform</li>
            <li>Customer-first approach</li>
        </ul>
    </div>
);

export default AboutUs;
